module.exports = __webpack_public_path__ + "img/brand-unti.4ccfd3ac.svg";